import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "py-3 px-6" }
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = {
  key: 0,
  class: ""
}
const _hoisted_4 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-3" }
const _hoisted_5 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-3" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { key: 1 }

import AdminLayout from '@/layouts/AdminLayout.vue';
import BranchesLayout from '../components/BranchesLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import PagePagination from '@/components/PagePagination.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import FileImportModal from '@/components/modal/FileImportModal.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import ActivityLogsTable from '@/components/ActivityLogsTable.vue';

import throttle from "lodash/throttle";
import company from "@/classes/Company";

import { paginatePage } from '@/helpers/PageHelper';
import { useRouter, useRoute } from 'vue-router';
import { onMounted, ref, watch, computed } from 'vue';

/**
 * ********************************
 * Data 
 * ********************************
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const route           = useRoute();
const router          = useRouter();
const seletected      = ref();
const errorMsg        = ref(null);
const loader          = ref(false);
const showError       = ref(false);
const showConfirmation = ref(false);
const showSuccess     = ref(false);
const dialog          = ref(false)
const branchId        = ref(route.params.id)
const currentRoutePath = computed(() => router.currentRoute.value.path);
const mainRoute = ref(`/branches/${branchId.value}/companies/`);

const searchText = ref();
const activeTab = ref();
const goToPage   = ref();
const tab   = ref('all');

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = computed(() => [
    {
        name: 'Active',
        count: active_count.value,
        href: mainRoute.value,
        allowed: true
    },
    {
        name: 'Archived',
        count: archived_count.value,
        href: `${mainRoute.value}archived`,
        allowed: true
    },
    {
        name: 'Activity logs',
        count: log_counts.value,
        href: `${mainRoute.value}logs`,
        allowed: 
            window.$hasPermission('view-activity-logs')
    }
]);

const headers: { text: string }[] = [
    { text: 'Company' },
    { text: 'Date Created'}
];

/**
 * ********************************
 * Page Renderer Data 
 * ********************************
 */
const items           = ref(null);
const items_count     = ref(0);
const rows            = ref(null);
const query           = ref(null);
const selected_tab    = ref(null);
const filterDate       = ref(null);
const log_event       = ref(null);
const log_query       = ref(null);
const log_date        = ref(null);
const active_count    = ref(0);
const archived_count  = ref(0);
const log_counts      = ref(0);
const logs            = ref({});
const log_event_lists = ref(null);

/**
 * ********************************
 * Methods
 * ********************************
 */
const indexCompany = async (data: string) => {
    try {
        loader.value = true;
        const queryString     = searchText.value ? `&query=${searchText.value}` : 'query';
        const dateQuery       = filterDate.value ? `&filterDate=${filterDate.value}` : '';
        const isArchivedRoute = currentRoutePath.value === `${mainRoute.value}archived`;
        const tabValue        = isArchivedRoute ? 'archived' : tab.value;
        const goToPageValue   = paginatePage(data);
        
        const response = await company.indexCompany(branchId.value, `${goToPageValue}&tab=${tabValue}&${queryString}&${dateQuery}`)
        
        loader.value = false;
        items.value           = response.data.items;
        items_count.value     = response.data.items_count
        rows.value            = response.data.rows
        query.value           = response.data.query
        selected_tab.value    = response.data.selected_tab
        filterDate.value       = response.data.filterDate
        log_event.value       = response.data.log_event
        log_query.value       = response.data.log_query
        log_date.value        = response.data.log_date
        active_count.value    = response.data.active_count
        archived_count.value  = response.data.archived_count
        log_counts.value      = response.data.log_counts
        logs.value            = response.data.logs
        log_event_lists.value = response.data.log_event_lists
    }
    catch(error) {
        loader.value = false;
        showError.value = true;
        errorMsg.value = error.response.data.message;
        
        if(error.response.status == 401) {
            window.location.replace('/login');
        }
    }
}

/**
 * ********************************
 * Methods 
 * ********************************
 */
const applyFilters = () => {
    indexCompany(goToPage.value)
}

const searchData = (val: string) => {
    searchText.value = val
}

const openModal = () => {
    dialog.value = true;
}

/**
 * ********************************
 * Archive Company 
 * ********************************
 */
 const selectedCompany = (id: string) => {
    showConfirmation.value = true
    seletected.value = id
}

const archiveCompany = async () => {
    try {
        loader.value = true;
        await company.deleteCompany(seletected.value);
        loader.value = false;
        window.location.replace(`${mainRoute.value}archived`);
    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err?.response?.data.message;
    }
};

/**
 * ********************************
 * Restore Company 
 * ********************************
 */
 const restoreCompany = async (id: string) => {
    try {
        loader.value = true;
        await company.restoreCompany(id);
        loader.value = false;
        window.location.replace(mainRoute.value)
    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err?.response?.data.message;
    }
};

/**
 * ********************************
 * Export Company 
 * ********************************
 */
 const exportData = async () => {
    try {
        loader.value = true;
        const queryString = searchText.value ? `&query=${searchText.value}` : '';
        const dateQuery   = filterDate.value ? `&filterDate=${filterDate.value}` : '';
        const params      = currentRoutePath.value == `${mainRoute.value}archived` ? 'tab=archived' : 'tab=all';

        await company.exportCompany(`${params}&branch_id=${branchId.value}${queryString}${dateQuery}`);

        showSuccess.value = true;
    } catch (error) {
        showError.value = true;
        errorMsg.value  = error.response?.data.message;
    } finally {
        loader.value = false;
    }
};

watch(
      searchText,
      throttle(() => {
        indexCompany(goToPage.value)
      }, 1000)
    );

onMounted( () => indexCompany(goToPage.value));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Companies",
    "show-back": "",
    backUrl: "/branches"
  }, {
    default: _withCtx(() => [
      _createVNode(BranchesLayout, { branchId: branchId.value }, {
        contents: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(TabComponent, {
              tabs: tabs.value,
              "button-items": true
            }, {
              buttons: _withCtx(() => [
                _createVNode(ButtonComponent, {
                  class: "text-gray-900",
                  secondary: "",
                  exportBtn: "",
                  onClick: exportData,
                  disabled: loader.value
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" Export ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(ButtonComponent, {
                  onClick: openModal,
                  class: "text-gray-900",
                  secondary: "",
                  importBtn: ""
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" Import ", -1)
                  ]))]),
                  _: 1
                }),
                (_ctx.$hasPermission('create-company'))
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      createBtn: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(`/branches/${branchId.value}/companies/create`)))
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode(" Create ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["tabs"])
          ]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(FilterComponent, {
              search: searchText.value,
              "text-filters": currentRoutePath.value !== `${mainRoute.value}logs`,
              onFetchData: searchData,
              "onUpdate:filters": applyFilters,
              "custom-filters": activeTab.value !== 'activity_logs'
            }, {
              fields: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(DatePicker, {
                    id: "filterDate",
                    name: "filterDate",
                    range: "",
                    is24: "",
                    isPresetRanges: "",
                    modelValue: filterDate.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterDate).value = $event)),
                    placeholder: "Start Date & End Date",
                    label: "Start Date & End Date"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["search", "text-filters", "custom-filters"])
          ]),
          (currentRoutePath.value !== `${mainRoute.value}logs`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(DataTable, {
                  headers: headers,
                  count: items.value?.data.length
                }, {
                  body: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_4, _toDisplayString(item.name), 1),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(item.formatted_created_at), 1),
                        _createElementVNode("td", _hoisted_6, [
                          (_ctx.$hasPermission('update-company'))
                            ? (_openBlock(), _createBlock(ActionButton, {
                                key: 0,
                                "edit-btn": "",
                                onClick: ($event: any) => (_unref(router).push(`/branches/${branchId.value}/companies/edit/${item.id}`))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (!item.deleted_at && _ctx.$hasPermission('archive-company'))
                            ? (_openBlock(), _createBlock(ActionButton, {
                                key: 1,
                                "delete-btn": "",
                                onClick: ($event: any) => (selectedCompany(item.id))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (item.deleted_at && _ctx.$hasPermission('restore-company'))
                            ? (_openBlock(), _createBlock(ActionButton, {
                                key: 2,
                                "restore-btn": "",
                                onClick: ($event: any) => (restoreCompany(item.id))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["count"]),
                _createVNode(PagePagination, {
                  class: "mb-6",
                  items: items.value,
                  onNextPage: indexCompany
                }, null, 8, ["items"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(ActivityLogsTable, {
                  logs: logs.value,
                  onFetchIndex: indexCompany
                }, null, 8, ["logs"])
              ]))
        ]),
        _: 1
      }, 8, ["branchId"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[4] || (_cache[4] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => {showConfirmation.value = false; archiveCompany() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Archive Company ?",
        content: "Are you sure you wish to archive this Company ?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Company Export",
        content: "Export is being processed. Please check your registered email."
      }, null, 8, ["show"]),
      _createVNode(FileImportModal, {
        title: "Branches",
        dialog: dialog.value,
        "import-route": `companies/import`,
        onOnClose: _cache[8] || (_cache[8] = ($event: any) => (dialog.value = false))
      }, null, 8, ["dialog"])
    ]),
    _: 1
  }))
}
}

})